import React from 'react';
import './Line.css';

function ShortLineGray() {
  return  <hr className="short-line-gray" />;
}

export default ShortLineGray;

